import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { NavLink, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const About = () => {
  const headingVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.1, // Delay for each letter
        type: "spring",
        stiffness: 120,
      },
    }),
  };
  const headingText = "About  MSB";

  const title = "About  MSB";

  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: index * 0.1, // Delay each letter animation
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };
  return (
    <div>
      <Helmet>
        {/* Basic Meta Tags */}
        <title>
          {" "}
          About MSB Association | Money Service Business Advocacy UK
        </title>
        <meta
          name="description"
          content="Learn about our mission and vision for the MSB sector. Discover how the MSB Association supports Money Service Businesses through advocacy & community networking."
        />

        {/* Open Graph Meta Tags */}
        <meta
          property="og:title"
          content="About MSB Association | Money Service Business Advocacy UK "
        />
        <meta
          property="og:description"
          content="Learn about our mission and vision for the MSB sector. Discover how the MSB Association supports Money Service Businesses through advocacy & community networking."
        />

        <meta property="og:type" content="website" />

        {/* Twitter Meta Tags */}
      </Helmet>
      <main className="page_content">
        {/* Page Header - Start
================================================== */}
        <section
          id="overview"
          className="page_header text-center  section_decoration overflow-hidden"
          style={{ background: "#333" }}
        >
          <div className="container">
            <motion.h1
              className="page_title text-white"
              initial="hidden"
              animate="visible"
              style={{ display: "flex", justifyContent: "center" }}
            >
              {title.split("").map((letter, index) => (
                <motion.span
                  key={index}
                  custom={index}
                  variants={letterVariants}
                  style={{
                    display: "inline-block",
                    marginRight: letter === " " ? "0.3rem" : "0",
                  }}
                >
                  {letter}
                </motion.span>
              ))}
            </motion.h1>
            <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li>
                <NavLink to="/">Home</NavLink>
              </li>
              <li className="active">
                <a href="#!">About MSB</a>
              </li>
            </ul>
          </div>
        </section>
        {/* Page Header - End
================================================== */}
        {/* Contact Section - Start
================================================== */}
        <section className="contact_section section_space bg-dark">
          <div className="container">
            <div className="item_details_content p-3">
              <h2 className="item_details_heading">
                {headingText.split("").map((char, i) => (
                  <motion.span
                    key={`${char}-${i}`}
                    custom={i}
                    initial="hidden"
                    animate="visible"
                    variants={headingVariants}
                  >
                    {char}
                  </motion.span>
                ))}
              </h2>
              <p>Welcome to the Money Service Business Association (MSBA)!</p>

              <h5>Who We Are?</h5>
              <p>
                The MSB Association is established to support money service
                businesses as they navigate the complexities of the financial
                industry. Our association brings together professionals who are
                passionate about fostering growth and innovation within this
                sector.
              </p>
              <hr />

              <h5>What We Do?</h5>
              <p>
                We are a non profit association providing support and guidance
                to Money Service Businesses with respect to:
              </p>

              <ul className="mt-0 pt-0">
                <li>
                  <h6>Advocacy-</h6>{" "}
                  <p>
                    Representing the interests of businesses in discussions with
                    regulatory bodies.
                  </p>
                </li>
                <li>
                  <h6>Education-</h6>{" "}
                  <p>
                    Offering resources, training, and workshops to help members
                    understand compliance and industry standards.
                  </p>
                </li>
                <li>
                  <h6>Networking-</h6>{" "}
                  <p>
                    Creating opportunities for members to connect and
                    collaborate with one another.
                  </p>
                </li>
                <li>
                  <h6>Resources-</h6>{" "}
                  <p>
                    Providing access to essential tools and guidance for
                    business development.
                  </p>
                </li>
              </ul>
              <h5>Join Us</h5>
              <p>
                If you're starting your journey in the money service industry or
                you are a veteran, consider joining the MSB Association.
                Together, we can build a supportive community that empowers new
                businesses to thrive.
              </p>
              <hr />

              <p>
                <i>
                  For more information about membership and resources, please
                  reach out to us at{" "}
                  <a href="mailto:info@msbassociationuk.org">
                    info@msbassociationuk.org
                  </a>{" "}
                </i>{" "}
              </p>
              <hr />
            </div>
            <div
              className="container p-5"
              style={{ background: "#fff", borderRadius: "10px" }}
            >
              <div className="row align-items-center">
                <div className="col-lg-7">
                  <h2 className="heading_text mb-0 p-4">
                    Let's make the MSB community stronger
                  </h2>
                </div>
                <div className="col-lg-5 text-lg-end p-3">
                  <NavLink
                    className="btn bg-primary text-dark btn-rounded"
                    to="/become-a-member"
                  >
                    <span className="btn_label">Become a Member</span>
                    <span className="btn_icon">
                      <svg
                        width="34"
                        height="24"
                        viewBox="0 0 34 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M33.0607 13.0607C33.6464 12.4749 33.6464 11.5251 33.0607 10.9393L23.5147 1.3934C22.9289 0.807609 21.9792 0.80761 21.3934 1.3934C20.8076 1.97918 20.8076 2.92893 21.3934 3.51472L29.8787 12L21.3934 20.4853C20.8076 21.0711 20.8076 22.0208 21.3934 22.6066C21.9792 23.1924 22.9289 23.1924 23.5147 22.6066L33.0607 13.0607ZM1.31134e-07 13.5L32 13.5L32 10.5L-1.31134e-07 10.5L1.31134e-07 13.5Z"
                          fill="black"
                        ></path>
                      </svg>
                    </span>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default About;
